const store = {
	USER_ID_KEY: "userId",

	checkLocalStorage() {
		const test = "coop-test-7849js838yrh84yh";
		try {
			localStorage.setItem(test, test);
			localStorage.removeItem(test);
			return true;
		} catch (e) {
			return false;
		}
	},

	getItem(key) {
		if (!this.checkLocalStorage()) {
			return null;
		}

		return window.localStorage.getItem(this.makeKey(key));
	},

	setItem(key, value) {
		if (!this.checkLocalStorage()) {
			return;
		}

		return window.localStorage.setItem(this.makeKey(key), value);
	},

	get userId() {
		return this.getItem(this.USER_ID_KEY) || null;
	},
	set userId(userId) {
		this.setItem(this.USER_ID_KEY, userId);
	},

	makeKey(key) {
		return "disco-2-" + key;
	},
};

export default store;
